"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fakeTeams = exports.fakeSites = exports.fakeRegions = exports.default = void 0;
var _Typography2 = _interopRequireDefault(require("@mui/material/Typography"));
var _Box2 = _interopRequireDefault(require("@mui/material/Box"));
var _Divider2 = _interopRequireDefault(require("@mui/material/Divider"));
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _findIllus = _interopRequireDefault(require("../../../assets/images/find-illus.svg"));
var _item = _interopRequireDefault(require("../companies-leaderboard/item"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const fakeSites = exports.fakeSites = [{
  key: 'tokyo',
  title: 'Tokyo',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'barcelone',
  title: 'Barcelone',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'bordeaux',
  title: 'Bordeaux',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'amsterdam',
  title: 'Amsterdam',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
const fakeTeams = exports.fakeTeams = [{
  key: 'dev',
  title: 'Développement',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'logistique',
  title: 'Logistique',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'sav',
  title: 'Service client',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'head',
  title: 'Direction',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
const fakeRegions = exports.fakeRegions = [{
  key: 'idf',
  title: 'île-de-France',
  activeMembers: 2345,
  journeys: 12_345,
  distance: 456_789_012
}, {
  key: 'nord',
  title: 'Nord',
  activeMembers: 456,
  journeys: 1_234,
  distance: 23_456_789
}, {
  key: 'so',
  title: 'Sud-Ouest',
  activeMembers: 234,
  journeys: 2_345,
  distance: 34_567_890
}, {
  key: 'ge',
  title: 'Grand Est',
  activeMembers: 123,
  journeys: 789,
  distance: 34_567_890
}];
function SubgroupsLeaderboard({
  FakeItemsCard,
  isFree,
  event,
  freeOfferSubgroupsLeaderboardsMaxRowsCount,
  displayType,
  leaderboard,
  count
}) {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return !leaderboard || leaderboard.length > 0 || isFree && freeOfferSubgroupsLeaderboardsMaxRowsCount === 0 ? /*#__PURE__*/_react.default.createElement(_Box2.default, {
    border: "1px solid #dde0e7",
    borderRadius: 2,
    display: "flex",
    flexDirection: "column",
    width: "100%"
  }, leaderboard ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, leaderboard.filter(({
    id
  }) => id).map(({
    id,
    rank,
    progressValue,
    username: title,
    participants
  }, index) => id && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: id
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    item: {
      id,
      type: 'company',
      activeParticipantsCount: participants || 0,
      participantsCount: participants || 0,
      leaderboardIndex: index + 1,
      rank,
      progressValue,
      title: title || '',
      parentId: -1,
      parentPhoto: null,
      parentTitle: '',
      photo: null,
      sizeRange: null,
      certified: false
    },
    prevItemRank: index > 0 ? leaderboard[index - 1].rank : null
  }))), isFree && count && count > freeOfferSubgroupsLeaderboardsMaxRowsCount && /*#__PURE__*/_react.default.createElement(FakeSubgroups, {
    displayType: displayType,
    event: event,
    FakeItemsCard: FakeItemsCard,
    freeOfferEmployeesLeaderboardsMaxRowsCount: freeOfferSubgroupsLeaderboardsMaxRowsCount
  })) : new Array(10).fill(null).map((_, index) => /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
    key: index
  }, index > 0 && /*#__PURE__*/_react.default.createElement(_Divider2.default, {
    sx: {
      borderColor: '#dde0e7'
    }
  }), /*#__PURE__*/_react.default.createElement(_item.default, {
    challengeType: event.challengeTemplate?.type,
    prevItemRank: null
  })))) : /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 3,
    paddingY: 5
  }, /*#__PURE__*/_react.default.createElement("img", {
    height: 64,
    src: _findIllus.default
  }), /*#__PURE__*/_react.default.createElement(_Box2.default, {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    gap: 1
  }, /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    fontWeight: 700
  }, t('commons.challenges.leaderboard.empty_state_title_company')), /*#__PURE__*/_react.default.createElement(_Typography2.default, {
    align: "center",
    variant: "body2"
  }, t('commons.challenges.leaderboard.empty_state_description'))));
}
function FakeSubgroups({
  FakeItemsCard,
  event,
  freeOfferEmployeesLeaderboardsMaxRowsCount,
  displayType
}) {
  const fakeGroups = displayType === 'companySite' || displayType === 'companySubsidiary' ? fakeSites : displayType === 'companyRegion' ? fakeRegions : fakeTeams;
  return /*#__PURE__*/_react.default.createElement(_Box2.default, {
    sx: {
      position: 'relative'
    }
  }, fakeGroups.map(({
    title,
    activeMembers
  }, index) => {
    const rank = freeOfferEmployeesLeaderboardsMaxRowsCount + 2;
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, {
      key: index
    }, (index > 0 || freeOfferEmployeesLeaderboardsMaxRowsCount > 0) && /*#__PURE__*/_react.default.createElement(_Divider2.default, {
      sx: {
        borderColor: '#dde0e7'
      }
    }), /*#__PURE__*/_react.default.createElement(_item.default, {
      blurred: true,
      challengeType: event.challengeTemplate?.type,
      item: {
        id: -1,
        type: 'company',
        activeParticipantsCount: 0,
        participantsCount: activeMembers,
        leaderboardIndex: rank + 1,
        rank,
        progressValue: 0,
        title,
        parentId: -1,
        parentPhoto: null,
        parentTitle: '',
        photo: null,
        sizeRange: null,
        certified: false
      },
      prevItemRank: freeOfferEmployeesLeaderboardsMaxRowsCount + 1
    }));
  }), /*#__PURE__*/_react.default.createElement(FakeItemsCard, {
    isEventWithOffer: true
  }));
}
var _default = exports.default = SubgroupsLeaderboard;